export default {
  account: {
    sidebar: {
      defaultName: 'Utilizador',
      accountDetails: 'Detalhes da Conta',
      orders: 'Encomendas',
      budgets: 'Orçamentos',
      history: 'Histórico',
      kits: 'Kits',
      favorites: 'Favoritos',
      tickets: 'Apoio ao Cliente',
      loyalty: 'Pontos de Fidelização',
      logout: 'Terminar Sessão',
    },
    loyalty: {
      title: 'Carteira de Fidelização',
      availablePoints: 'Pontos Disponíveis',
      frozenPoints: 'Pontos Congelados',
      infoTitle: 'Como funciona',
      pointsPerEuro: 'Ganha {{pointsPerEuro}} ponto(s) por cada €1 gasto.',
      maxRedeemablePoints: 'Pode resgatar até {{maxRedeemablePoints}} pontos por encomenda, em troca de um desconto.',
      frozenPointsInfo: 'Os pontos congelados estão reservados para um desconto atualmente aplicado a uma encomenda e não podem ser resgatados novamente até essa reserva ser libertada.',
      loadError: 'Ocorreu um erro ao carregar a sua carteira de fidelização.',
    },
    settings: {
      back: 'Voltar',
      navTitle: 'A minha conta',
      personalInfoNav: 'Informações Pessoais',
      addressListNav: 'Lista de endereços',
      privacyNav: 'Privacidade e Dados',
      loadError: 'Ocorreu um erro ao carregar os dados.',
      noCustomer: 'Nenhum cliente autenticado.',
      personal: {
        title: 'Informação pessoal',
        editAriaLabel: 'Editar',
        cancel: 'Cancelar',
        save: 'Guardar',
        firstNameLabel: 'Primeiro Nome',
        lastNameLabel: 'Último Nome',
        emailLabel: 'Email',
        phoneLabel: 'Telemóvel',
        nifLabel: 'NIF',
        emailChangePasswordLabel: 'Palavra-passe atual*',
        emailChangePasswordPlaceholder: 'Necessária para confirmar a alteração de email',
        emailChangeNotice: 'Enviaremos um link de confirmação para o novo email. A alteração só é aplicada depois de confirmar.',
        emailChangePasswordRequired: 'Introduza a palavra-passe atual para alterar o email.',
        emailChangeSuccess: 'Enviámos um email de confirmação para o novo endereço. A alteração só é aplicada depois de confirmar através do link enviado.',
        emailChangeInvalidPassword: 'A palavra-passe atual está incorreta. Os restantes dados foram guardados, mas o email não foi alterado.',
        emailChangeConflict: 'Este email já está a ser utilizado. Os restantes dados foram guardados, mas o email não foi alterado.',
        emailChangeGenericError: 'Erro ao pedir a alteração de email.',
        updateSuccess: 'Dados atualizados com sucesso.',
        updateError: 'Erro ao atualizar dados.',
      },
      addresses: {
        title: 'Lista de endereços',
        addNew: '+ Adicionar novo',
        emptyTitle: 'Não há nada para ver aqui',
        emptyDescription: 'Ainda não tem endereços guardados',
        tableName: 'Nome',
        tablePhone: 'Telemóvel',
        tableAddress: 'Morada',
        defaultBadge: 'Predefinido',
        editAriaLabel: 'Editar',
        deleteAriaLabel: 'Eliminar',
        deleteConfirm: 'Eliminar a morada de {{name}}?',
        deleteDefaultName: 'este contacto',
        deleteSuccess: 'Morada eliminada com sucesso.',
        deleteError: 'Erro ao eliminar morada.',
      },
      privacy: {
        title: 'Privacidade e Dados',
        marketingLabel: 'Comunicações de marketing',
        marketingDescription: 'Receber emails sobre ofertas, novos produtos e promoções.',
        marketingUpdateSuccess: 'Preferência atualizada com sucesso.',
        marketingUpdateError: 'Erro ao atualizar a sua preferência.',
        exportLabel: 'Exportar os meus dados',
        exportDescription: 'Descarregue uma cópia do seu perfil, moradas e histórico de encomendas.',
        exportButton: 'Descarregar',
        exportError: 'Erro ao exportar os seus dados.',
        deleteTitle: 'Eliminar conta',
        deleteDescription: 'Elimina permanentemente a sua conta e anonimiza os seus dados pessoais. Esta ação não pode ser revertida.',
        deleteButton: 'Eliminar a minha conta',
        deleteConfirm: 'Tem a certeza? Esta ação não pode ser revertida.',
        deleteConfirmButton: 'Sim, eliminar a minha conta',
        deleteCancel: 'Cancelar',
        deleteSuccess: 'A sua conta foi eliminada.',
        deleteError: 'Erro ao eliminar a sua conta.',
      },
    },
    addressModal: {
      closeAriaLabel: 'Fechar',
      editTitle: 'Editar morada',
      addTitle: 'Adicionar morada',
      firstNameLabel: 'Primeiro Nome',
      lastNameLabel: 'Último Nome',
      companyLabel: 'Empresa',
      streetLine1Label: 'Morada',
      streetLine2Label: 'Complemento',
      postalCodeLabel: 'Código Postal',
      cityLabel: 'Cidade',
      provinceLabel: 'Estado / Província',
      countryLabel: 'País',
      selectCountry: 'Selecionar país',
      phoneLabel: 'Telemóvel',
      defaultShippingLabel: 'Morada de envio predefinida',
      defaultBillingLabel: 'Morada de faturação predefinida',
      cancel: 'Cancelar',
      save: 'Guardar',
      add: 'Adicionar',
      updateSuccess: 'Morada atualizada com sucesso.',
      createSuccess: 'Morada adicionada com sucesso.',
      saveError: 'Erro ao guardar morada.',
      validation: {
        firstNameRequired: 'Primeiro nome é obrigatório',
        lastNameRequired: 'Último nome é obrigatório',
        streetLine1Required: 'Morada é obrigatória',
        postalCodeRequired: 'Código postal é obrigatório',
        cityRequired: 'Cidade é obrigatória',
        countryRequired: 'País é obrigatório',
      },
    },
    addressListModal: {
      closeAriaLabel: 'Fechar',
      title: 'Lista de Moradas',
      deselectAll: 'Desmarcar todos',
      selectAll: 'Selecionar todos',
      tableName: 'Nome',
      tableContact: 'Contacto',
      tableAddress: 'Morada',
      selectAriaLabel: 'Selecionar {{name}}',
      emptyState: 'Nenhuma morada guardada. Adicione moradas na sua conta.',
      useThisAddress: 'Usar esta morada',
      confirmSelection: 'Confirmar seleção',
    },
    addressForm: {
      streetLine1Label: 'Morada',
      postalCodeLabel: 'Código postal',
      cityLabel: 'Cidade',
      provinceLabel: 'Província',
      countryLabel: 'País',
    },
    verifyEmailChange: {
      invalidLinkTitle: 'Link inválido',
      invalidLinkDescription: 'O link de confirmação de email é inválido ou está incompleto.',
      backToAccount: 'Voltar à minha conta',
      pending: 'A confirmar a alteração de email...',
      successTitle: 'Email atualizado',
      successDescription: 'O seu email foi alterado com sucesso.',
      errorTitle: 'Não foi possível confirmar',
      tokenExpired: 'O link de confirmação expirou. Peça a alteração de email novamente a partir da sua conta.',
      tokenInvalid: 'O link de confirmação é inválido.',
      genericError: 'Ocorreu um erro ao confirmar a alteração de email.',
    },
    page: {
      breadcrumbHome: 'Início',
      breadcrumbLabel: 'Área pessoal - {{section}}',
      myAccount: 'A Minha Conta',
      budgetDetails: 'Detalhes do Orçamento',
      loyalty: 'Pontos de Fidelização',
      historyDetails: 'Detalhes do Histórico',
      ordersLoadError: 'Ocorreu um erro ao carregar as encomendas.',
    },
  },
  alerts: {
    loadErrorTitle: 'Erro ao carregar alertas',
    previousAriaLabel: 'Anterior',
    nextAriaLabel: 'Próximo',
    goToAlertAriaLabel: 'Ir para alerta {{number}}',
    imageAlt: 'Ilustração de alerta promocional da loja',
    closeAriaLabel: 'Fechar alertas',
  },
  storeUnavailable: {
    title: 'Desculpe, Esta loja não está disponível.',
    subtitle: 'Tente novamente mais tarde.',
    imageAlt: 'Ilustração de loja indisponível',
  },
  checkout: {
    shippingAddress: {
      back: 'Voltar',
      title: 'Endereço de envio',
      edit: 'Editar',
      howToShip: 'Como gostaria de enviar este kit?',
      options: {
        singleTitle: 'Enviar para um único endereço',
        singleDescription: 'Enviar presente para uma pessoa ou empresa.',
        multipleTitle: 'Enviar para múltiplos endereços',
        multipleDescription: 'Enviar presente para um grupo ou cliente.',
      },
      form: {
        firstNameLabel: 'Primeiro Nome*',
        lastNameLabel: 'Último Nome*',
        addressLabel: 'Endereço*',
        companyLabel: 'Empresa',
        postalCodeLabel: 'Código Postal*',
        cityLabel: 'Cidade*',
        countryLabel: 'País*',
        selectCountry: 'Selecionar País',
        countryPT: 'Portugal',
        countryES: 'Espanha',
        countryFR: 'França',
        countryGB: 'Reino Unido',
        stateLabel: 'Estado / Província*',
        billingSameAsShipping: 'O endereço de faturação é igual ao endereço de envio',
        phoneLabel: 'Telemóvel*',
        billingTitle: 'Endereço de faturação',
        billingCountryLabel: 'País',
        saveToProfile: 'Guardar esta morada na minha conta',
        submitSaving: 'A guardar...',
        submitContinue: 'Continuar para a entrega',
      },
      multiple: {
        selectAddressesPrompt: 'Selecione pelo menos duas moradas guardadas na sua conta para dividir a entrega.',
        selectDeliveryAddresses: 'Selecionar moradas de entrega',
        needTwoAddressesAuth: 'Adicione pelo menos duas moradas na sua conta para usar esta opção.',
        needTwoAddressesGuest: 'Inicie sessão e guarde pelo menos duas moradas na sua conta para usar esta opção.',
        selectAtLeastPrefix: 'Selecione pelo menos',
        selectAtLeastBold: '2 moradas',
        selectAtLeastSuffix: 'para dividir a entrega.',
        selectedAddressesTitle: 'Moradas selecionadas',
        viewAddressList: 'Ver Lista de Endereços',
        assignQuantitiesTitle: 'Associar quantidades às moradas',
        assignQuantitiesDescription: 'Adicione uma linha por morada e indique quantas unidades de cada produto seguem para lá. A quantidade total de cada produto tem de ficar totalmente distribuída.',
        nonSplittableNotice: 'Kits e conjuntos de produtos são enviados por inteiro para a morada principal e não aparecem na tabela abaixo.',
        noEligibleItems: 'Não existem produtos elegíveis para divisão por morada.',
        addShippingRow: '+ Adicionar linha de envio',
        addressColumn: 'Morada',
        allocatedOf: '{{allocated}} / {{quantity}} atribuído',
        selectAddress: 'Selecionar morada',
        removeRowAriaLabel: 'Remover linha',
        addAnotherRow: '+ Adicionar outra linha',
        remainingTitle: 'Ainda falta atribuir:',
        ofCountUnassigned: 'de {{count}} por atribuir',
        fullyAllocated: 'Todos os produtos estão totalmente distribuídos pelas moradas.',
      },
      review: {
        contacts: 'Contactos',
      },
      delivery: {
        sectionTitle: 'Envio',
        noEligibleMethods: 'Nenhum método de envio elegível para a morada selecionada.',
        continueToPayment: 'Continuar para pagamento',
        methodLabel: 'Método',
        methodSelectedFallback: 'Método selecionado',
      },
      payment: {
        sectionTitle: 'Pagamento',
        noEligibleMethods: 'Nenhum método de pagamento disponível.',
        reviewOrder: 'Rever encomenda',
        methodLabel: 'Método de pagamento',
      },
      reviewSection: {
        title: 'Rever Encomenda',
        legalText: 'Ao clicar no botão Finalizar encomenda, confirma que leu, compreende e aceita os nossos Termos de Utilização, Condições de Venda e Política de Devoluções e reconhece que leu a Política de Privacidade da {{storeName}}.',
        placeOrder: 'Finalizar encomenda',
      },
      steps: {
        review: 'Rever',
      },
      summary: {
        title: 'Resumo',
        subtotal: 'Subtotal',
        itemsCount: '({{count}} Items)',
        discounts: 'Descontos',
        shipping: 'Envio',
        free: 'Grátis',
        taxes: 'Impostos',
        total: 'Total',
        waiting: 'A aguardar...',
        continue: 'Continuar',
      },
      errors: {
        distributeQuantities: 'Distribua a quantidade total de cada produto pelas moradas antes de continuar.',
        setCustomerFailed: 'Erro ao definir os dados do cliente.',
        reopenOrderFailed: 'Erro ao reabrir a encomenda para edição.',
        selectValidAddress: 'Selecione uma morada válida para a primeira linha de envio.',
        setShippingAddressFailed: 'Erro ao definir morada de entrega.',
        setBillingAddressFailed: 'Erro ao definir morada de faturação.',
        saveSplitFailed: 'Erro ao guardar a divisão de entrega.',
        clearSplitFailed: 'Erro ao limpar a divisão de entrega.',
        addressesSavedSuccess: 'Moradas guardadas com sucesso!',
        processAddressesFailed: 'Erro ao processar as moradas.',
        reopenAddressFailed: 'Erro ao reabrir a morada para edição.',
        editAddressFailed: 'Erro ao editar a morada.',
        selectShippingMethod: 'Por favor, selecione um método de envio.',
        setShippingMethodFailed: 'Erro ao definir o método de envio.',
        advanceToPaymentFailed: 'Erro ao avançar para pagamento.',
        processShippingMethodFailed: 'Erro ao processar o método de envio.',
        reopenShippingFailed: 'Erro ao reabrir o envio para edição.',
        editShippingMethodFailed: 'Erro ao editar o método de envio.',
        orderNotFound: 'Encomenda não encontrada.',
        processPaymentFailed: 'Erro ao processar o pagamento.',
        orderPlacedSuccess: 'A sua encomenda foi realizada com sucesso!',
        placeOrderFailed: 'Erro ao finalizar a encomenda.',
      },
      countryNames: {
        PT: 'Portugal',
        ES: 'Spain',
        FR: 'France',
        GB: 'United Kingdom',
      },
    },
  },
}
